import { CreateBtn } from 'lib/styles/icons';
import { boxStyle } from 'lib/styles/index';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import PlaceInsertModal from './PlaceInsertModal';

const PlaceBox = ({ edit }) => {
  const { store, updateStore, insertStore } = useSelector(
    ({ contract }) => contract.contractRegisterForm,
  );
  const [showInsertModal, setShowInsertModal] = useState(false);

  return (
    <>
      {showInsertModal && (
        <PlaceInsertModal
          closeModal={() => setShowInsertModal(false)}
          edit={edit}
        />
      )}
      <PlaceBoxBlock>
        {updateStore?.map((updateStore, idx) => (
          <div className="place-box-card" key={`updateStore-${idx}`}>
            <div>{updateStore.name}</div>
            <div>{updateStore.address}</div>
            <div>{updateStore.detailAddress}</div>
          </div>
        ))}
        {insertStore?.map((insertStore, idx) => (
          <div className="place-box-card" key={`insertStore-${idx}`}>
            <div>{insertStore.name}</div>
            <div>{insertStore.address}</div>
            <div>{insertStore.detailAddress}</div>
          </div>
        ))}
        {store.length === 0 && updateStore.length === 0 && !edit ? (
          <div style={{ fontWeight: 500, marginTop: 20 }}>
            1개 이상 입력 필수
          </div>
        ) : (
          store.map((store, idx) => (
            <div className="place-box-card" key={`store-${idx}`}>
              <div>{store.name}</div>
              <div>{store.address}</div>
              <div>{store.detailAddress}</div>
            </div>
          ))
        )}
        <CreateBtn className="icon" onClick={() => setShowInsertModal(true)} />
      </PlaceBoxBlock>
    </>
  );
};

export default PlaceBox;

const PlaceBoxBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .place-box-card {
    ${boxStyle}
    width: 80%;
    margin-top: 1rem;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    font-weight: 500;
    text-align: center;
    div + div {
      margin-top: 0.3rem;
    }
  }

  .icon {
    margin-top: 20px;
    font-size: 24px;
  }
`;
